var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navbar'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('p',[_vm._v("Blog")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }